import { PINNED_ID, PROMOTIONS_ID, PROMOTIONS_TITLE } from '@app/store/modules/ui/sportOffer/constants';
import i18n from '@app/localization/i18n';
import { ScrollerItem } from './ScrollerItem';
import { HeaderType } from '../enums';
import { sportName } from '../util';
import { ElementHeights } from '../constants';

const PINNED_TITLE = i18n.t('Pinned Events');

/**
 * The specification for all objects rendered as categories in the event grid.
 * (e.g. Football, Baseball, Promotions.)
 */
export interface Category extends ScrollerItem {
    // This interface adds only to the semantic meaning
}

export function createCategory(id: number, title: string, heights: ElementHeights): Category {
    return {
        title,
        id: `${id}`,
        type: HeaderType.category,
        height: heights.categoryHeader,
    } as Category;
}

export function createSportCategory(sportId: number, heights: ElementHeights) {
    return createCategory(sportId, sportName(sportId), heights);
}

export function createPromotionsCategory(heights: ElementHeights) {
    return createCategory(PROMOTIONS_ID, PROMOTIONS_TITLE, heights);
}

export function createPinnedEventsCategory(heights: ElementHeights) {
    return createCategory(PINNED_ID, PINNED_TITLE.toString(), heights);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/modules/eventGrid/gridUnits/Category.ts